import { useQuery } from '@tanstack/react-query'
import useAxios from './useAxios'

const useCommonGetAPI = (url) => {
    const callApi = useAxios()
    return useQuery(
        ['COMMON_GET_API', url],
        () =>
            callApi({
                method: 'GET',
                url: url,
            }).then((data) => data),
        {
            enabled: Boolean(url),
        },
    )
}

export default useCommonGetAPI
